export const blockIconsHardwareDevicesNew = (
	<span className='material-symbols-outlined'>devices</span>
);
